import React from 'react'
import { Route, Routes, useNavigate } from 'react-router-dom'

import useDocumentTitle from 'hooks/document-title'
import { usePersistedState } from 'hooks/persisted-state'
import AccountPage from './Account'
import PlanPage from './Plan'
import IntellitagsPage from './Intellitags'
import CheckoutPage from './Checkout'
import ShippingPage from './Shipping'
import type {
  AccountInput,
  CheckoutInput,
  IntellitagsInput,
  PlanInput,
  ShippingInput,
} from 'services/orders'

const LOCAL_STORAGE_KEY = 'promo-code-signup-state'

function PromoCodeSignupPage() {
  useDocumentTitle('Intellitage Activation | Pet Notify')
  const navigate = useNavigate()
  const [state, setState] = usePersistedState<Partial<CheckoutInput>>(
    {},
    LOCAL_STORAGE_KEY,
  )

  const handleAccountComplete = (data: AccountInput) => {
    setState((s) => ({ ...s, ...data }))
    navigate('plan')
  }

  const handlePlanComplete = (data: PlanInput) => {
    setState((s) => ({ ...s, ...data }))
    navigate('intellitags')
  }

  function handleShippingSubmit(data: ShippingInput) {
    setState((s) => ({ ...s, shippingAddress: data }))
    navigate(`checkout`)
  }

  function handleIntellitagsSubmit(data: IntellitagsInput) {
    setState((s) => ({ ...s, order: data }))
    navigate(`shipping`)
  }

  const handleCheckoutComplete = () => {
    localStorage.removeItem(LOCAL_STORAGE_KEY)
    window.location.replace('/?activated=true')
  }

  return (
    <Routes>
      <Route
        path='checkout'
        element={
          <CheckoutPage state={state} onComplete={handleCheckoutComplete} />
        }
      />
      <Route
        path='shipping'
        element={
          <ShippingPage
            state={state.shippingAddress}
            onComplete={handleShippingSubmit}
          />
        }
      />
      <Route
        path='intellitags'
        element={
          <IntellitagsPage
            state={state.order}
            onComplete={handleIntellitagsSubmit}
          />
        }
      />
      <Route
        path='plan'
        element={<PlanPage state={state} onComplete={handlePlanComplete} />}
      />
      <Route
        index
        element={
          <AccountPage state={state} onComplete={handleAccountComplete} />
        }
      />
    </Routes>
  )
}

export default PromoCodeSignupPage
